import React, { useState } from "react";

import Context from "./index";

const AuthProvider = (props) => {
  let localAuth = JSON.parse(localStorage.getItem("authenticated")) || false;
  let localVendorAuth =
    JSON.parse(localStorage.getItem("vendorAuthenticated")) || false;

  const [authenticated, setAuthenticated] = useState(localAuth);
  const [vendorAuthenticated, setVendorAuthenticated] =
    useState(localVendorAuth);

  // Vendor-specific state
  const [vendorToken, setVendorToken] = useState(
    localStorage.getItem("vendorToken"),
  );

  return (
    <Context.Provider
      value={{
        authenticated,
        setAuthenticated,
        vendorAuthenticated,
        setVendorAuthenticated,
        vendorToken,
        setVendorToken,
      }}
    >
      {props.children}
    </Context.Provider>
  );
};

export default AuthProvider;
